import { generateActions, generateSelectors, generateTypes } from "../util";

export const key = "comments";

// create comment
export const CREATE_COMMENT = generateTypes(key, "create");
export const [createComment, createCommentSuccess, createCommentError, createCommentBusy] =
  generateActions(CREATE_COMMENT);
export const [selectCreateComment, selectCreateCommentError, selectCreateCommentBusy, , selectCreateCommentRequest] =
  generateSelectors(CREATE_COMMENT);
